import { CALL_RECORDINGS_LOADING, CALL_RECORDINGS_SUCCESS, CALL_RECORDINGS_FAILED, CALL_RECORDINGS_RESET } from '../actions/voiceLogs.action';
import { CallRecordsReducer } from '../models/voiceLogs.interface';

const initialState: CallRecordsReducer = {
    callRecordsData: {},
    callRecordsLoading: false,
    callRecordsError: false,
    callRecordsErrorMsg: ''
}

const callRecordsReducer = (state: CallRecordsReducer = initialState, action: any): CallRecordsReducer => {

    switch (action.type) {
        case CALL_RECORDINGS_LOADING:
            return {
                ...state,
                callRecordsLoading: true,
                callRecordsError: false
            }
        case CALL_RECORDINGS_SUCCESS:
            return {
                ...state,
                callRecordsLoading: false,
                callRecordsError: false,
                callRecordsData: action.payload.res,
            }
        case CALL_RECORDINGS_FAILED:
            return {
                ...state,
                callRecordsLoading: false,
                callRecordsError: true,
                callRecordsErrorMsg: action.payload
            }
        case CALL_RECORDINGS_RESET:
            return initialState
        default:
            return state;
    }
}

export default callRecordsReducer;